module.exports = "pre {\n  background-color: #f5f5f5;\n  padding: 15px;\n}"